var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TeamStatusControl',{attrs:{"subject":_vm.slide.settings.subject,"type":"answers"},on:{"subcommand":_vm.subcommand}})
}
var staticRenderFns = []

export { render, staticRenderFns }